module.exports = __webpack_public_path__ + "img/6_150.ba71d48b.png";